<template>
  <section class=" weblog-comments-section border-r-20 p-4 mt-4 commentForm" >
    <div class="w-100">
      <div class="d-flex justify-content-start w-100" style="gap: 11px" v-if="blogStatus">
        <b-skeleton type="button" />
        <b-skeleton type="button" />
      </div>
      <div class="d-flex align-items-baseline gap-8" v-else>
        <span>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.69591 13.391C7.05115 13.391 6.52734 12.8672 6.52734 12.2224C6.52734 11.5795 7.05115 11.0557 7.69591 11.0557C8.34068 11.0557 8.86449 11.5795 8.86449 12.2224C8.86449 12.8672 8.34068 13.391 7.69591 13.391ZM12.2388 13.391C11.594 13.391 11.0702 12.8672 11.0702 12.2224C11.0702 11.5795 11.594 11.0557 12.2388 11.0557C12.8836 11.0557 13.4074 11.5795 13.4074 12.2224C13.4074 12.8672 12.8836 13.391 12.2388 13.391ZM15.6132 12.2224C15.6132 12.8672 16.137 13.391 16.7818 13.391C17.4265 13.391 17.9503 12.8672 17.9503 12.2224C17.9503 11.5795 17.4265 11.0557 16.7818 11.0557C16.137 11.0557 15.6132 11.5795 15.6132 12.2224Z" fill="#105730"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.02 2C6.21 2 2 6.74612 2 12.015C2 13.6975 2.49 15.4291 3.35 17.0115C3.51 17.2729 3.53 17.6024 3.42 17.9139L2.75 20.1572C2.6 20.698 3.06 21.0976 3.57 20.9374L5.59 20.3375C6.14 20.1572 6.57 20.3866 7.08 20.698C8.54 21.5583 10.36 22 12 22C16.96 22 22 18.1642 22 11.985C22 6.65598 17.7 2 12.02 2Z" stroke="#105730" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
        <h6 class="text-color-grey font-w-900 fontsize-medium m-0">ارسال نظرات</h6>
      </div>
      <br v-if="blogStatus"/>
      <p v-else class="d-inline-block text-color-444 fontsize-mini">
        نشانی ایمیل شما منتشر نخواهد شد
      </p>
      <CommentForm @commentAdded="onCommentAdded" v-if="blog" :blog-id="blog.post.id" />
    </div>
    <!-- <div class="white-bg mt-4 weblog-comments" id="legal-questions">
      <template v-if="blogStatus"><b-skeleton v-for="i in 4" :key="i"></b-skeleton></template>
     
      <template v-if="blog && !blogStatus">
        <div v-for="(comment, index) in blog.post.comments" :key="'comment' + index" class="pb-md-0">
          <div class="user-question">
            
            <Comment @commentAdded="onCommentAdded" @answer="answer" :blog-id="blog.post.id" :answering-comment="answeringComment" :answerable="true" :comment="comment" />
          </div>
          <template v-if="comment.children.length != 0">
            
            <div v-for="(childComment, index) in comment.children"
                 :key="'answer' + index" class="d-flex py-3 px-sm-5 pl-4 pr-1 admin-answer">
              <div class="answer-tab-content-img ml-3">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.294 7.29105C17.294 10.2281 14.9391 12.5831 12 12.5831C9.0619 12.5831 6.70601 10.2281 6.70601 7.29105C6.70601 4.35402 9.0619 2 12 2C14.9391 2 17.294 4.35402 17.294 7.29105ZM12 22C7.66237 22 4 21.295 4 18.575C4 15.8539 7.68538 15.1739 12 15.1739C16.3386 15.1739 20 15.8789 20 18.599C20 21.32 16.3146 22 12 22Z" fill="#fff"/>
                </svg>
              </div>
              <Comment :answerable="false" :comment="childComment" />
            </div>
          </template>
        </div> 
      </template>
    </div>-->
  </section>
</template>

<script>
import CommentForm from "@/parts/Front/components/weblog/CommentForm";
import Comment from "@/parts/Front/components/weblog/Comment";
import {BSkeleton} from 'bootstrap-vue'

export default {
  name: "CommentSection",
  components: {Comment, CommentForm, BSkeleton},
  data() {
    return {
      answeringComment: null
    }
  },
  methods: {
    answer(commentId) {
      if (this.answeringComment === commentId) {
        this.answeringComment = null
      } else {
        this.answeringComment = commentId
        this.$nextTick(() => {
          document.querySelector('#form-' + commentId + ' input').focus();
        })
      }
    },
    onCommentAdded(comment) {
      if (comment) {
        this.blog.post.comments.unshift(comment)
      }
      this.answeringComment = null;
    }
  },
  computed: {
    blogStatus() {
      return this.$store.getters["front/getBlogDetailStatus"];
    },
    blog() {
      return this.$store.getters["front/getBlogDetail"];
    },
  },
}
</script>
<style scoped>
.commentForm{
  background-color: #FFF;
  box-shadow: 0px 0px 37px 5px #BABABA63;

}
</style>